import styled from 'styled-components';

import {
  Input as SemanticInput,
} from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Header as HeaderLayoutComponent,
  Loader as LoaderLayoutComponent,
  Text as TextLayoutComponent,
  Toggle as ToggleLayoutComponent,
} from '@playbookux/playbook-web-core';

import SearchLayoutComponent from '../../../../core/layout-components/search';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  overflow-y: hidden;
`;

export const ContainerEmailInvite = styled.div`
  display: flex;
  alignItems: center;
  justifyContent: start;
`;

export const ContainerRow = styled.div`
  display: flex;
  ${({ hasMarginBottom }) => hasMarginBottom && `
    margin-bottom: 20px;
  `}
`;

export const MessageContainer = styled.div`
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const MessageContainerBelow = styled.div`
  margin-left: 20px;
  width: fit-content;
`;

export const Section = styled.div`
  max-width: 1252px;
  margin-bottom: 20px;
  overflow: ${(props) => (props.overflow || 'hidden')};
`;

export const ToggleWrapper = styled.div`
  margin-left: 15px;
`;

export const Toggle = styled(ToggleLayoutComponent)``;

export const Title = styled(HeaderLayoutComponent)`
  margin-bottom: 15px;
`;

export const SearchContainer = styled.div`
  max-width: 520px;
  margin-bottom: 20px;
`;

export const Search = styled(SearchLayoutComponent).attrs({
  isWritten: true,
})``;

export const Subtitle = styled(HeaderLayoutComponent)`
  margin: 0 0 5px 0;
`;

export const Description = styled(TextLayoutComponent)`
  width: 520px;
  margin-bottom: 20px;
  ${({ textAlign }) => textAlign && `
    text-align: center;
  `}
`;

export const DescriptionSecondary = styled(TextLayoutComponent.Secondary)`
  width: 520px;
  margin-bottom: 5px;
`;

export const ErrorMessage = styled(TextLayoutComponent.Error)`
  ${({ bold }) => bold && `
    font-weight: 500;
  `}
  margin-top: 5px;
`;

export const SuccessMessage = styled(TextLayoutComponent)`
  color: ${(props) => props.theme.color.success};
  font-weight: 500;
`;

export const Input = styled(SemanticInput)`
  width: 400px;
  margin-right: 20px;
  margin-bottom: 5px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    width: 100px;
    ${({ hasMarginTop }) => hasMarginTop && `
      margin-top: 20px;
    `}
  }
`;

export const Link = styled.a`
  margin-left: 4px;
`;

export const Loader = styled(LoaderLayoutComponent)``;

export const Message = styled(TextLayoutComponent)`
  ${({ description }) => description && `
    display: flex;
    font-size: 16px;
    width: 300px;
  `}
  ${({ bold }) => bold && `
    font-weight: 500;
  `}
  max-width: 760px;
`;

export const ContainerLoading = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
`;
